import { render, staticRenderFns } from "./disciplinaDaTurma.vue?vue&type=template&id=40717da8&"
import script from "./disciplinaDaTurma.vue?vue&type=script&lang=js&"
export * from "./disciplinaDaTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports